import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { getEntitlement } from '../actions/entitlements';

export default handleActions({
  [getEntitlement]: {
    next(state, { payload: { catalogId, entitled } }) {
      return {
        ...state,
        [catalogId]: entitled
      };
    },
  },
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/entitlements.js